import * as Types from '../../network/graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MessageTextFragment = { __typename?: 'ConversationMessageText', id: string, message: string, createdAt: Date, author: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null }, attachments: Array<{ __typename?: 'ConversationMessageAttachmentNotShipment', customerId: string } | { __typename?: 'ConversationMessageAttachmentShipment', shipment: { __typename?: 'Shipment', id: string, status: Types.ShipmentStatus, createdAt: Date, orderedProductsCount: number, totalOrderedProductsAmount: number, shippingAddress: { __typename?: 'ShippingAddress', inputCity: string }, customer: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null } } } | { __typename?: 'ConversationMessageAttachmentShow' }> };

export type MessageImageFragment = { __typename?: 'ConversationMessageImage', createdAt: Date, id: string, url: any, author: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null } };

export type ConversationFragment = { __typename?: 'Conversation', id: string, hasUnreadMessages: boolean, lastMessage: { __typename?: 'ConversationMessageImage', id: string, createdAt: Date } | { __typename?: 'ConversationMessageText', id: string, message: string, createdAt: Date }, otherParticipant: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null } };

export type GetConversationsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetConversationsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, conversations: { __typename?: 'ConversationConnection', totalCount: number, edges: Array<{ __typename?: 'ConversationEdge', node: { __typename?: 'Conversation', id: string, hasUnreadMessages: boolean, lastMessage: { __typename?: 'ConversationMessageImage', id: string, createdAt: Date } | { __typename?: 'ConversationMessageText', id: string, message: string, createdAt: Date }, otherParticipant: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type GetConversationQueryVariables = Types.Exact<{
  conversationId: Types.Scalars['ID']['input'];
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetConversationQuery = { __typename?: 'Query', node: { __typename?: 'AutoFollowUserCampaign' } | { __typename?: 'AutocompleteSearchItem' } | { __typename?: 'Badge' } | { __typename?: 'Break' } | { __typename?: 'BreakTemplate' } | { __typename?: 'Category' } | { __typename?: 'CommercialEvent' } | { __typename?: 'Conversation', id: string, otherParticipant: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null }, messages: { __typename?: 'ConversationMessageConnection', edges: Array<{ __typename?: 'ConversationMessageEdge', node: { __typename?: 'ConversationMessageImage', createdAt: Date, id: string, url: any, author: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null } } | { __typename?: 'ConversationMessageText', id: string, message: string, createdAt: Date, author: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null }, attachments: Array<{ __typename?: 'ConversationMessageAttachmentNotShipment', customerId: string } | { __typename?: 'ConversationMessageAttachmentShipment', shipment: { __typename?: 'Shipment', id: string, status: Types.ShipmentStatus, createdAt: Date, orderedProductsCount: number, totalOrderedProductsAmount: number, shippingAddress: { __typename?: 'ShippingAddress', inputCity: string }, customer: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null } } } | { __typename?: 'ConversationMessageAttachmentShow' }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | { __typename?: 'ConversationMessageImage' } | { __typename?: 'ConversationMessageText' } | { __typename?: 'Country' } | { __typename?: 'Emote' } | { __typename?: 'FavoriteProduct' } | { __typename?: 'FavoriteShow' } | { __typename?: 'ImageUpload' } | { __typename?: 'InventoryProduct' } | { __typename?: 'Language' } | { __typename?: 'LoyaltyLevel' } | { __typename?: 'Order' } | { __typename?: 'OrderedProduct' } | { __typename?: 'ParentCategory' } | { __typename?: 'Product' } | { __typename?: 'ProductForOrdering' } | { __typename?: 'Promotion' } | { __typename?: 'PromotionV2' } | { __typename?: 'RatingFromCustomer' } | { __typename?: 'SellerChannel' } | { __typename?: 'SellerLedgerPayout' } | { __typename?: 'SellerLedgerTransaction' } | { __typename?: 'SellerShowsAggregatedByMonth' } | { __typename?: 'SellerTier' } | { __typename?: 'Shipment' } | { __typename?: 'Shop' } | { __typename?: 'Show' } | { __typename?: 'ShowOrdersGroup' } | { __typename?: 'ShowProductNode' } | { __typename?: 'User' } | { __typename?: 'UserSellerLoyaltyProgress' } | { __typename?: 'WheelTemplate' } };

export type SendMessageInConversationMutationVariables = Types.Exact<{
  input: Types.SendMessageInConversationInput;
}>;


export type SendMessageInConversationMutation = { __typename?: 'Mutation', sendMessageInConversation: { __typename?: 'ConversationMessageText', conversationId: string, id: string, message: string, createdAt: Date, author: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null }, attachments: Array<{ __typename?: 'ConversationMessageAttachmentNotShipment', customerId: string } | { __typename?: 'ConversationMessageAttachmentShipment', shipment: { __typename?: 'Shipment', id: string, status: Types.ShipmentStatus, createdAt: Date, orderedProductsCount: number, totalOrderedProductsAmount: number, shippingAddress: { __typename?: 'ShippingAddress', inputCity: string }, customer: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null } } } | { __typename?: 'ConversationMessageAttachmentShow' }> } };

export type MarkMessageAndOlderAsReadMutationVariables = Types.Exact<{
  input: Types.MarkMessageAndOlderAsReadInput;
}>;


export type MarkMessageAndOlderAsReadMutation = { __typename?: 'Mutation', markMessageAndOlderAsRead: { __typename?: 'MarkMessageAndOlderAsReadPayload', ok: boolean } };

export type MarkConversationAsUnreadMutationVariables = Types.Exact<{
  input: Types.MarkConversationAsUnreadInput;
}>;


export type MarkConversationAsUnreadMutation = { __typename?: 'Mutation', markConversationAsUnread: { __typename?: 'MarkConversationAsUnreadPayload', ok: boolean } };

export type GetHasUnreadConversationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetHasUnreadConversationsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, hasUnreadConversations: boolean } | null };

export type ReportUserProfileMutationVariables = Types.Exact<{
  input: Types.ReportUserProfileInput;
}>;


export type ReportUserProfileMutation = { __typename?: 'Mutation', reportUserProfile: { __typename?: 'ReportUserProfilePayload', ok: boolean } };

export type PersonalEventSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type PersonalEventSubscription = { __typename?: 'Subscription', personalEvent: { __typename?: 'PersonalEventConversationNewMessage', message: { __typename?: 'ConversationMessageImage', conversationId: string, createdAt: Date, id: string, url: any, author: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null } } | { __typename?: 'ConversationMessageText', conversationId: string, id: string, message: string, createdAt: Date, author: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null }, attachments: Array<{ __typename?: 'ConversationMessageAttachmentNotShipment', customerId: string } | { __typename?: 'ConversationMessageAttachmentShipment', shipment: { __typename?: 'Shipment', id: string, status: Types.ShipmentStatus, createdAt: Date, orderedProductsCount: number, totalOrderedProductsAmount: number, shippingAddress: { __typename?: 'ShippingAddress', inputCity: string }, customer: { __typename?: 'User', id: string, username: string, avatarWebPUrl?: string | null } } } | { __typename?: 'ConversationMessageAttachmentShow' }> } } | { __typename?: 'PersonalEventModal' } };

export type GetConversationWithCustomerQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type GetConversationWithCustomerQuery = { __typename?: 'Query', conversationWithCustomer?: { __typename?: 'Conversation', id: string } | null };

export type SendMessageRelatedToShipmentMutationVariables = Types.Exact<{
  input: Types.SendMessageRelatedToShipmentInput;
}>;


export type SendMessageRelatedToShipmentMutation = { __typename?: 'Mutation', sendMessageRelatedToShipment: { __typename?: 'ConversationMessageText', id: string, message: string, createdAt: Date } };

export type SendMessageRelatedToUnshippedCustomerMutationVariables = Types.Exact<{
  input: Types.SendMessageRelatedToUnshippedCustomerInput;
}>;


export type SendMessageRelatedToUnshippedCustomerMutation = { __typename?: 'Mutation', sendMessageRelatedToUnshippedCustomer: { __typename?: 'ConversationMessageText', conversationId: string } };

export const MessageTextFragmentDoc = gql`
    fragment MessageText on ConversationMessageText {
  id
  message
  author {
    id
    username
    avatarWebPUrl(options: {width: 64})
  }
  createdAt
  attachments {
    ... on ConversationMessageAttachmentShipment {
      shipment {
        id
        status
        shippingAddress {
          inputCity
        }
        createdAt
        orderedProductsCount
        totalOrderedProductsAmount
        customer {
          id
          username
          avatarWebPUrl
        }
      }
    }
    ... on ConversationMessageAttachmentNotShipment {
      customerId
    }
  }
}
    `;
export const MessageImageFragmentDoc = gql`
    fragment MessageImage on ConversationMessageImage {
  author {
    id
    username
    avatarWebPUrl(options: {width: 64})
  }
  createdAt
  id
  url
}
    `;
export const ConversationFragmentDoc = gql`
    fragment Conversation on Conversation {
  id
  lastMessage {
    ... on ConversationMessageText {
      id
      message
      createdAt
    }
    ... on ConversationMessageImage {
      id
      createdAt
    }
  }
  hasUnreadMessages
  otherParticipant {
    id
    username
    avatarWebPUrl
  }
}
    `;
export const GetConversationsDocument = gql`
    query GetConversations($first: Int!, $after: String) {
  viewer {
    id
    conversations(first: $first, after: $after) {
      edges {
        node {
          ...Conversation
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    ${ConversationFragmentDoc}`;

/**
 * __useGetConversationsQuery__
 *
 * To run a query within a React component, call `useGetConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetConversationsQuery(baseOptions: Apollo.QueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables> & ({ variables: GetConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
      }
export function useGetConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
        }
export function useGetConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
        }
export type GetConversationsQueryHookResult = ReturnType<typeof useGetConversationsQuery>;
export type GetConversationsLazyQueryHookResult = ReturnType<typeof useGetConversationsLazyQuery>;
export type GetConversationsSuspenseQueryHookResult = ReturnType<typeof useGetConversationsSuspenseQuery>;
export type GetConversationsQueryResult = Apollo.QueryResult<GetConversationsQuery, GetConversationsQueryVariables>;
export const GetConversationDocument = gql`
    query GetConversation($conversationId: ID!, $first: Int!, $after: String) {
  node(id: $conversationId) {
    ... on Conversation {
      id
      otherParticipant {
        id
        username
        avatarWebPUrl
      }
      messages(first: $first, after: $after) {
        edges {
          node {
            ... on ConversationMessageText {
              ...MessageText
            }
            ... on ConversationMessageImage {
              ...MessageImage
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    ${MessageTextFragmentDoc}
${MessageImageFragmentDoc}`;

/**
 * __useGetConversationQuery__
 *
 * To run a query within a React component, call `useGetConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetConversationQuery(baseOptions: Apollo.QueryHookOptions<GetConversationQuery, GetConversationQueryVariables> & ({ variables: GetConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
      }
export function useGetConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
        }
export function useGetConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
        }
export type GetConversationQueryHookResult = ReturnType<typeof useGetConversationQuery>;
export type GetConversationLazyQueryHookResult = ReturnType<typeof useGetConversationLazyQuery>;
export type GetConversationSuspenseQueryHookResult = ReturnType<typeof useGetConversationSuspenseQuery>;
export type GetConversationQueryResult = Apollo.QueryResult<GetConversationQuery, GetConversationQueryVariables>;
export const SendMessageInConversationDocument = gql`
    mutation SendMessageInConversation($input: SendMessageInConversationInput!) {
  sendMessageInConversation(input: $input) {
    ...MessageText
    conversationId
  }
}
    ${MessageTextFragmentDoc}`;
export type SendMessageInConversationMutationFn = Apollo.MutationFunction<SendMessageInConversationMutation, SendMessageInConversationMutationVariables>;

/**
 * __useSendMessageInConversationMutation__
 *
 * To run a mutation, you first call `useSendMessageInConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageInConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageInConversationMutation, { data, loading, error }] = useSendMessageInConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMessageInConversationMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageInConversationMutation, SendMessageInConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageInConversationMutation, SendMessageInConversationMutationVariables>(SendMessageInConversationDocument, options);
      }
export type SendMessageInConversationMutationHookResult = ReturnType<typeof useSendMessageInConversationMutation>;
export type SendMessageInConversationMutationResult = Apollo.MutationResult<SendMessageInConversationMutation>;
export type SendMessageInConversationMutationOptions = Apollo.BaseMutationOptions<SendMessageInConversationMutation, SendMessageInConversationMutationVariables>;
export const MarkMessageAndOlderAsReadDocument = gql`
    mutation MarkMessageAndOlderAsRead($input: MarkMessageAndOlderAsReadInput!) {
  markMessageAndOlderAsRead(input: $input) {
    ok
  }
}
    `;
export type MarkMessageAndOlderAsReadMutationFn = Apollo.MutationFunction<MarkMessageAndOlderAsReadMutation, MarkMessageAndOlderAsReadMutationVariables>;

/**
 * __useMarkMessageAndOlderAsReadMutation__
 *
 * To run a mutation, you first call `useMarkMessageAndOlderAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMessageAndOlderAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMessageAndOlderAsReadMutation, { data, loading, error }] = useMarkMessageAndOlderAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkMessageAndOlderAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkMessageAndOlderAsReadMutation, MarkMessageAndOlderAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkMessageAndOlderAsReadMutation, MarkMessageAndOlderAsReadMutationVariables>(MarkMessageAndOlderAsReadDocument, options);
      }
export type MarkMessageAndOlderAsReadMutationHookResult = ReturnType<typeof useMarkMessageAndOlderAsReadMutation>;
export type MarkMessageAndOlderAsReadMutationResult = Apollo.MutationResult<MarkMessageAndOlderAsReadMutation>;
export type MarkMessageAndOlderAsReadMutationOptions = Apollo.BaseMutationOptions<MarkMessageAndOlderAsReadMutation, MarkMessageAndOlderAsReadMutationVariables>;
export const MarkConversationAsUnreadDocument = gql`
    mutation MarkConversationAsUnread($input: MarkConversationAsUnreadInput!) {
  markConversationAsUnread(input: $input) {
    ok
  }
}
    `;
export type MarkConversationAsUnreadMutationFn = Apollo.MutationFunction<MarkConversationAsUnreadMutation, MarkConversationAsUnreadMutationVariables>;

/**
 * __useMarkConversationAsUnreadMutation__
 *
 * To run a mutation, you first call `useMarkConversationAsUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkConversationAsUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markConversationAsUnreadMutation, { data, loading, error }] = useMarkConversationAsUnreadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkConversationAsUnreadMutation(baseOptions?: Apollo.MutationHookOptions<MarkConversationAsUnreadMutation, MarkConversationAsUnreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkConversationAsUnreadMutation, MarkConversationAsUnreadMutationVariables>(MarkConversationAsUnreadDocument, options);
      }
export type MarkConversationAsUnreadMutationHookResult = ReturnType<typeof useMarkConversationAsUnreadMutation>;
export type MarkConversationAsUnreadMutationResult = Apollo.MutationResult<MarkConversationAsUnreadMutation>;
export type MarkConversationAsUnreadMutationOptions = Apollo.BaseMutationOptions<MarkConversationAsUnreadMutation, MarkConversationAsUnreadMutationVariables>;
export const GetHasUnreadConversationsDocument = gql`
    query GetHasUnreadConversations {
  viewer {
    id
    hasUnreadConversations
  }
}
    `;

/**
 * __useGetHasUnreadConversationsQuery__
 *
 * To run a query within a React component, call `useGetHasUnreadConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasUnreadConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasUnreadConversationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHasUnreadConversationsQuery(baseOptions?: Apollo.QueryHookOptions<GetHasUnreadConversationsQuery, GetHasUnreadConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHasUnreadConversationsQuery, GetHasUnreadConversationsQueryVariables>(GetHasUnreadConversationsDocument, options);
      }
export function useGetHasUnreadConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHasUnreadConversationsQuery, GetHasUnreadConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHasUnreadConversationsQuery, GetHasUnreadConversationsQueryVariables>(GetHasUnreadConversationsDocument, options);
        }
export function useGetHasUnreadConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHasUnreadConversationsQuery, GetHasUnreadConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHasUnreadConversationsQuery, GetHasUnreadConversationsQueryVariables>(GetHasUnreadConversationsDocument, options);
        }
export type GetHasUnreadConversationsQueryHookResult = ReturnType<typeof useGetHasUnreadConversationsQuery>;
export type GetHasUnreadConversationsLazyQueryHookResult = ReturnType<typeof useGetHasUnreadConversationsLazyQuery>;
export type GetHasUnreadConversationsSuspenseQueryHookResult = ReturnType<typeof useGetHasUnreadConversationsSuspenseQuery>;
export type GetHasUnreadConversationsQueryResult = Apollo.QueryResult<GetHasUnreadConversationsQuery, GetHasUnreadConversationsQueryVariables>;
export const ReportUserProfileDocument = gql`
    mutation ReportUserProfile($input: ReportUserProfileInput!) {
  reportUserProfile(input: $input) {
    ok
  }
}
    `;
export type ReportUserProfileMutationFn = Apollo.MutationFunction<ReportUserProfileMutation, ReportUserProfileMutationVariables>;

/**
 * __useReportUserProfileMutation__
 *
 * To run a mutation, you first call `useReportUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportUserProfileMutation, { data, loading, error }] = useReportUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<ReportUserProfileMutation, ReportUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportUserProfileMutation, ReportUserProfileMutationVariables>(ReportUserProfileDocument, options);
      }
export type ReportUserProfileMutationHookResult = ReturnType<typeof useReportUserProfileMutation>;
export type ReportUserProfileMutationResult = Apollo.MutationResult<ReportUserProfileMutation>;
export type ReportUserProfileMutationOptions = Apollo.BaseMutationOptions<ReportUserProfileMutation, ReportUserProfileMutationVariables>;
export const PersonalEventDocument = gql`
    subscription PersonalEvent {
  personalEvent {
    ... on PersonalEventConversationNewMessage {
      message {
        ... on ConversationMessageImage {
          ...MessageImage
          conversationId
        }
        ... on ConversationMessageText {
          ...MessageText
          conversationId
        }
      }
    }
  }
}
    ${MessageImageFragmentDoc}
${MessageTextFragmentDoc}`;

/**
 * __usePersonalEventSubscription__
 *
 * To run a query within a React component, call `usePersonalEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePersonalEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalEventSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePersonalEventSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PersonalEventSubscription, PersonalEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PersonalEventSubscription, PersonalEventSubscriptionVariables>(PersonalEventDocument, options);
      }
export type PersonalEventSubscriptionHookResult = ReturnType<typeof usePersonalEventSubscription>;
export type PersonalEventSubscriptionResult = Apollo.SubscriptionResult<PersonalEventSubscription>;
export const GetConversationWithCustomerDocument = gql`
    query GetConversationWithCustomer($customerId: ID!) {
  conversationWithCustomer(customerId: $customerId) {
    id
  }
}
    `;

/**
 * __useGetConversationWithCustomerQuery__
 *
 * To run a query within a React component, call `useGetConversationWithCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationWithCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationWithCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetConversationWithCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetConversationWithCustomerQuery, GetConversationWithCustomerQueryVariables> & ({ variables: GetConversationWithCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationWithCustomerQuery, GetConversationWithCustomerQueryVariables>(GetConversationWithCustomerDocument, options);
      }
export function useGetConversationWithCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationWithCustomerQuery, GetConversationWithCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationWithCustomerQuery, GetConversationWithCustomerQueryVariables>(GetConversationWithCustomerDocument, options);
        }
export function useGetConversationWithCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationWithCustomerQuery, GetConversationWithCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationWithCustomerQuery, GetConversationWithCustomerQueryVariables>(GetConversationWithCustomerDocument, options);
        }
export type GetConversationWithCustomerQueryHookResult = ReturnType<typeof useGetConversationWithCustomerQuery>;
export type GetConversationWithCustomerLazyQueryHookResult = ReturnType<typeof useGetConversationWithCustomerLazyQuery>;
export type GetConversationWithCustomerSuspenseQueryHookResult = ReturnType<typeof useGetConversationWithCustomerSuspenseQuery>;
export type GetConversationWithCustomerQueryResult = Apollo.QueryResult<GetConversationWithCustomerQuery, GetConversationWithCustomerQueryVariables>;
export const SendMessageRelatedToShipmentDocument = gql`
    mutation SendMessageRelatedToShipment($input: SendMessageRelatedToShipmentInput!) {
  sendMessageRelatedToShipment(input: $input) {
    id
    message
    createdAt
  }
}
    `;
export type SendMessageRelatedToShipmentMutationFn = Apollo.MutationFunction<SendMessageRelatedToShipmentMutation, SendMessageRelatedToShipmentMutationVariables>;

/**
 * __useSendMessageRelatedToShipmentMutation__
 *
 * To run a mutation, you first call `useSendMessageRelatedToShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageRelatedToShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageRelatedToShipmentMutation, { data, loading, error }] = useSendMessageRelatedToShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMessageRelatedToShipmentMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageRelatedToShipmentMutation, SendMessageRelatedToShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageRelatedToShipmentMutation, SendMessageRelatedToShipmentMutationVariables>(SendMessageRelatedToShipmentDocument, options);
      }
export type SendMessageRelatedToShipmentMutationHookResult = ReturnType<typeof useSendMessageRelatedToShipmentMutation>;
export type SendMessageRelatedToShipmentMutationResult = Apollo.MutationResult<SendMessageRelatedToShipmentMutation>;
export type SendMessageRelatedToShipmentMutationOptions = Apollo.BaseMutationOptions<SendMessageRelatedToShipmentMutation, SendMessageRelatedToShipmentMutationVariables>;
export const SendMessageRelatedToUnshippedCustomerDocument = gql`
    mutation SendMessageRelatedToUnshippedCustomer($input: SendMessageRelatedToUnshippedCustomerInput!) {
  sendMessageRelatedToUnshippedCustomer(input: $input) {
    conversationId
  }
}
    `;
export type SendMessageRelatedToUnshippedCustomerMutationFn = Apollo.MutationFunction<SendMessageRelatedToUnshippedCustomerMutation, SendMessageRelatedToUnshippedCustomerMutationVariables>;

/**
 * __useSendMessageRelatedToUnshippedCustomerMutation__
 *
 * To run a mutation, you first call `useSendMessageRelatedToUnshippedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageRelatedToUnshippedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageRelatedToUnshippedCustomerMutation, { data, loading, error }] = useSendMessageRelatedToUnshippedCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMessageRelatedToUnshippedCustomerMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageRelatedToUnshippedCustomerMutation, SendMessageRelatedToUnshippedCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageRelatedToUnshippedCustomerMutation, SendMessageRelatedToUnshippedCustomerMutationVariables>(SendMessageRelatedToUnshippedCustomerDocument, options);
      }
export type SendMessageRelatedToUnshippedCustomerMutationHookResult = ReturnType<typeof useSendMessageRelatedToUnshippedCustomerMutation>;
export type SendMessageRelatedToUnshippedCustomerMutationResult = Apollo.MutationResult<SendMessageRelatedToUnshippedCustomerMutation>;
export type SendMessageRelatedToUnshippedCustomerMutationOptions = Apollo.BaseMutationOptions<SendMessageRelatedToUnshippedCustomerMutation, SendMessageRelatedToUnshippedCustomerMutationVariables>;